import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { SolicitudExtenderComponent } from '../solicitud-extender/solicitud-extender.component';
import { ISolicitudAdicionarInfoModel } from 'src/app/models/interfaces/solicitud/ISolicitudAdicionarInfoModel';

@Component({
  selector: 'app-solicitud-adicionar-info',
  templateUrl: './solicitud-adicionar-info.component.html',
  styleUrls: ['./solicitud-adicionar-info.component.scss']
})
export class SolicitudAdicionarInfoComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SolicitudExtenderComponent>,
    private solicitudService: SolicitudService,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public model: ISolicitudAdicionarInfoModel) { }

  ngOnInit() {
  }

  onSubmit(form: NgForm) {
    this.solicitudService.adicionarinfo(this.model).subscribe((result : ActionResultModel) => {
      if(result.type!=eTypeResult.SUCCESS){
        this.alertDialogService.open(result.message);
      }    
      else{  
        this.alertDialogService.open('Se envió la solicitud correctamente.');
      }
    });
  }

  onNoClick(){
    this.dialogRef.close();
  }

}
